/**
 * Admin Portal → Codes: every route of the one Codes area, and the old addresses' redirects (Codes
 * PR-8). One list, so the portal (web/src/AdminApp.tsx) and the redirect tests mount exactly the same
 * routes. Paths are relative to `/admin/*`; `wrap` puts each page in the portal's layout.
 *
 * Web-only (the admin SPA): react-router is fine here.
 */

import React from 'react';
import { Route } from 'react-router-dom';
import { CodesActivity } from './CodesActivity';
import { CodesAllCodes } from './CodesAllCodes';
import { CodesApi } from './CodesApi';
import { CodesIssue } from './CodesIssue';
import { CodesOffers } from './CodesOffers';
import { CodesOverview } from './CodesOverview';
import { CodesRedirect } from './CodesRedirect';
import { CodesStoreInventory } from './CodesStoreInventory';
import { CODES_ROUTES, LEGACY_REDIRECTS } from './codesAreaLogic';

const rel = (path: string): string => path.replace(/^\/admin\//, '');

export function codesRouteElements(wrap: (page: React.ReactElement) => React.ReactElement): React.ReactElement[] {
  const pages: Array<[string, React.ReactElement]> = [
    [CODES_ROUTES.overview, <CodesOverview />],
    [CODES_ROUTES.all, <CodesAllCodes />],
    [CODES_ROUTES.batches, <CodesAllCodes view="batches" />],
    [`${CODES_ROUTES.batches}/:batchId`, <CodesAllCodes view="batches" />],
    [CODES_ROUTES.offers, <CodesOffers />],
    [CODES_ROUTES.store, <CodesStoreInventory />],
    [CODES_ROUTES.storeSetup, <CodesStoreInventory view="setup" />],
    [CODES_ROUTES.issue, <CodesIssue />],
    [CODES_ROUTES.issueHouse, <CodesIssue owner="house" />],
    [CODES_ROUTES.issuePartner, <CodesIssue owner="partner" />],
    [CODES_ROUTES.api, <CodesApi />],
    [CODES_ROUTES.activity, <CodesActivity />],
  ];
  return [
    ...pages.map(([path, page]) => <Route key={path} path={rel(path)} element={wrap(page)} />),
    // Bookmarks: each old address lands on the screen that replaced it, its query string kept.
    ...LEGACY_REDIRECTS.map((r) => <Route key={`legacy:${r.from}`} path={rel(r.from)} element={<CodesRedirect to={r.to} />} />),
  ];
}
